(function(){
"use strict";
var FQ_DIRTY=false;  // true = quiz in corso, avvisa prima di ricaricare/uscire
// --- rete di sicurezza: se la configurazione manca o è rotta, si va avanti lo stesso ---
if(!window.FQ_CONFIG){
  console.error("FQ: configurazione mancante o con errore di sintassi. Uso i valori di riserva.");
  window.FQ_CONFIG={};
}
var _D={formula:{variantId:0,preis:0,preisVergleich:null,label:"",detail:""},
        bilder:{bereiche:{},kunden:[]},ronaldo:{titel:"",text:""},stimmen:[],
        zutaten:[],faq:[],upsell:[],maxUpsell:3,demo:true};
for(var _k in _D){ if(window.FQ_CONFIG[_k]==null) window.FQ_CONFIG[_k]=_D[_k]; }
if(!window.FQ_CONFIG.bilder.bereiche) window.FQ_CONFIG.bilder.bereiche={};
if(!window.FQ_CONFIG.bilder.kunden)   window.FQ_CONFIG.bilder.kunden=[];

const C=window.FQ_CONFIG,R=document.getElementById("fq"),$=s=>R?R.querySelector(s):null;
if(!R){ console.error("FQ: contenitore #fq non trovato."); return; }
const IMG=C.bilder||{};

/* ---------- DOSE ---------- */
function jar(){
  if(IMG.produkt) return `<img src="${IMG.produkt}" alt="Deine persönliche Formel">`;
  let g="";
  for(let i=0;i<130;i++){
    const x=92+Math.random()*136,y=96+Math.random()*30,r=1.5+Math.random()*2.2;
    const c=["#e8a33d","#d9743a","#f0d9a8","#c9542f","#efe3c4"][Math.floor(Math.random()*5)];
    g+=`<circle cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="${c}" opacity="${(.6+Math.random()*.4).toFixed(2)}"/>`;
  }
  return `<svg viewBox="0 0 320 360" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="jb" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stop-color="#3b3193"/><stop offset="26%" stop-color="#6155e0"/>
        <stop offset="62%" stop-color="#8b7dff"/><stop offset="100%" stop-color="#3f3499"/></linearGradient>
      <linearGradient id="jl" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stop-color="#4a3fc4"/><stop offset="45%" stop-color="#7a6cf0"/><stop offset="100%" stop-color="#453ab0"/></linearGradient>
      <clipPath id="jc"><rect x="88" y="92" width="144" height="40"/></clipPath>
    </defs>
    <ellipse cx="160" cy="336" rx="86" ry="12" fill="#0d1024" opacity=".13"/>
    <path d="M88 112 h144 v186 a22 22 0 0 1 -22 22 h-100 a22 22 0 0 1 -22 -22 z" fill="url(#jb)"/>
    <ellipse cx="160" cy="112" rx="72" ry="20" fill="#241d6b"/>
    <g clip-path="url(#jc)"><ellipse cx="160" cy="112" rx="66" ry="17" fill="#1a1550"/>${g}</g>
    <rect x="82" y="74" width="156" height="34" rx="10" fill="url(#jl)"/>
    <rect x="82" y="74" width="156" height="8" rx="4" fill="#fff" opacity=".18"/>
    <rect x="104" y="176" width="112" height="82" rx="8" fill="#fff" opacity=".93"/>
    <text x="160" y="200" text-anchor="middle" font-family="Sora,sans-serif" font-size="13" font-weight="700" fill="#171a33">DEINE</text>
    <text x="160" y="219" text-anchor="middle" font-family="Sora,sans-serif" font-size="13" font-weight="700" fill="#171a33">FORMEL</text>
    <line x1="120" y1="228" x2="200" y2="228" stroke="#d8dce8"/>
    <text x="160" y="245" text-anchor="middle" font-family="Azeret Mono,monospace" font-size="6.5" fill="#5d6382" letter-spacing="1.2">30 TAGE · 2 MESSLÖFFEL</text>
    <rect x="88" y="112" width="16" height="208" fill="#fff" opacity=".10"/>
  </svg>`;
}
$("#fq-jar1").innerHTML=(IMG.hero?`<img src="${IMG.hero}" alt="Deine persönliche Formel">`:jar())
  +`<div class="fq-scoops">Einnahme<b>2 Messlöffel / Tag</b></div>`;

/* ---------- BILD-SLOTS ---------- */
function slot(id,url,ph){
  const el=$(id); if(!el) return;
  el.innerHTML = url ? `<img src="${url}" alt="">` : `<span class="ph">${ph}</span>`;
}
slot("#fq-im-granulat", IMG.granulat, "Bild: Granulate");
slot("#fq-im-bewertung", IMG.bewertung, "Bild: Wellness-Check");
slot("#fq-im-aufnahme",  IMG.aufnahme,  "Bild: Aufnahme");
slot("#fq-im-qualitaet", IMG.qualitaet, "Bild: Qualität");
if(IMG.anwendung){const s=$("#fq-step4");
  if(s) s.querySelector(".ic").outerHTML=`<img src="${IMG.anwendung}" alt="Einnahme">`;}

/* ---------- ZUTATEN-LAUFBAND ---------- */
(function(){
  const z=(C.zutaten||[]);
  const chip=x=>`<span class="fq-z">${x.bild?`<img src="${x.bild}" alt="">`:`<i></i>`}${x.name}</span>`;
  $("#fq-track").innerHTML = z.map(chip).join("") + z.map(chip).join("");  // doppelt für nahtlose Schleife
})();

/* ---------- VIER BEREICHE ---------- */
const BEREICHE=[
 {k:"haut", tab:"Schönheit & Wohlbefinden", h:"Schönheit und Wohlbefinden",
  p:"Für alle, die sich wohl in ihrer Haut fühlen — und es auch sehen wollen.",
  b:["Trägt zur Erhaltung normaler Haut bei","Trägt zur Erhaltung normaler Haare und Nägel bei",
     "Trägt zu einer normalen Kollagenbildung bei","Trägt zum Schutz der Zellen vor oxidativem Stress bei"]},
 {k:"kraft", tab:"Sport & Leistung", h:"Sport und Leistung",
  p:"Für aktive Menschen, die ihre körperliche Leistung nährstoffseitig unterstützen wollen.",
  b:["Trägt zur normalen Muskelfunktion bei","Trägt zu einem normalen Energiestoffwechsel bei",
     "Trägt zur Verringerung von Müdigkeit und Ermüdung bei","Trägt zur Erhaltung normaler Knochen bei"]},
 {k:"geist", tab:"Kognitive Funktion", h:"Kognitive und psychische Funktion",
  p:"Für alle, denen Konzentration und geistige Klarheit im Alltag wichtig sind.",
  b:["Trägt zur normalen Funktion des Nervensystems bei","Trägt zur normalen kognitiven Funktion bei",
     "Trägt zur normalen psychischen Funktion bei"]},
 {k:"altern", tab:"Langfristiges Wohlbefinden", h:"Langfristiges Wohlbefinden",
  p:"Für alle, die den ganzen Organismus und die kommenden Jahre im Blick haben.",
  b:["Trägt zur Erhaltung normaler Knochen bei","Trägt zur normalen Funktion des Immunsystems bei",
     "Trägt zu einer normalen Herzfunktion bei","Trägt zum Schutz der Zellen vor oxidativem Stress bei"]}
];
function bereich(i){
  const b=BEREICHE[i];
  const url=(IMG.bereiche||{})[b.k];
  $("#fq-tabs").querySelectorAll(".fq-tab").forEach((t,j)=>t.classList.toggle("on",j===i));
  $("#fq-panel").innerHTML=`<div class="fq-panel">
    <div class="fq-pimg">${url?`<img src="${url}" alt="">`:`<span class="ph">Bild: ${b.tab}</span>`}</div>
    <div><h3>${b.h}</h3><p>${b.p}</p>
      <ul class="fq-bl">${b.b.map(x=>`<li>${x}</li>`).join("")}</ul>
      <button class="fq-btn" data-a="start">Meine Formel erstellen</button>
    </div></div>`;
}
$("#fq-tabs").innerHTML=BEREICHE.map((b,i)=>`<button class="fq-tab" data-b="${i}">${b.tab}</button>`).join("");
$("#fq-tabs").querySelectorAll(".fq-tab").forEach((t,i)=>t.addEventListener("click",()=>bereich(i)));
bereich(0);

/* ---------- RONALDO (nur wenn im Config ausgefüllt) ---------- */
(function(){
  const r=C.ronaldo||{};
  if(!r.text || !r.text.trim()) return;
  $("#fq-ron-sec").style.display="block";
  $("#fq-ron-t").textContent=r.titel||"";
  $("#fq-ron-p").textContent=r.text;
  $("#fq-ron-img").innerHTML=IMG.ronaldo?`<img src="${IMG.ronaldo}" alt="">`:"";
})();

/* ---------- KUNDEN (nur wenn Fotos oder Stimmen vorhanden) ---------- */
(function(){
  const fotos=IMG.kunden||[], stimmen=C.stimmen||[];
  if(!fotos.length && !stimmen.length) return;
  $("#fq-kunden-sec").style.display="block";
  if(fotos.length){
    const im=u=>`<img src="${u}" alt="">`;
    $("#fq-ktrack").innerHTML=fotos.map(im).join("")+fotos.map(im).join("");
  } else { $("#fq-ktrack").parentElement.style.display="none"; }
  $("#fq-stimmen").innerHTML=stimmen.map(s=>
    `<div class="fq-stimme"><p>„${s.text}"</p>
     <div class="who">${s.bild?`<img src="${s.bild}" alt="">`:""}<span>${s.name}</span></div></div>`).join("");
})();

/* ---------- FAQ ---------- */
(function(){
  const f=C.faq||[];
  $("#fq-faq").innerHTML=f.map((x,i)=>
    `<div class="fq-fi" data-i="${i}">
       <button class="fq-fq" type="button"><span>${x.f}</span><span class="x">+</span></button>
       <div class="fq-fa"><p>${x.a}</p></div>
     </div>`).join("");
  $("#fq-faq").querySelectorAll(".fq-fq").forEach(btn=>btn.addEventListener("click",()=>{
    const it=btn.parentElement;
    const wasOpen=it.classList.contains("on");
    $("#fq-faq").querySelectorAll(".fq-fi").forEach(x=>x.classList.remove("on"));
    if(!wasOpen) it.classList.add("on");
  }));
})();

/* ---------- DIE 7 BEREICHE ---------- */
const AREE={
 energie:{n:"Energie",s:"Energie",d:"Eisen, Magnesium und B-Vitamine gegen die Tiefs im Tagesverlauf.",
  nutri:[["Vitamin B12","Rote Blutkörperchen und Energie"],["Eisen","Sauerstofftransport"],["Magnesium","Muskeln, Schlaf und Energie"],["Vitamin B6","Stimmung und Nervensystem"],["Pantothensäure","Energiestoffwechsel"]]},
 geist:{n:"Kognitive Funktion",s:"Geist",d:"Unterstützung für Konzentration, Gedächtnis und Klarheit.",
  nutri:[["Omega-3 DHA","Struktur des Gehirns"],["Vitamin B6","Neurotransmitter"],["Jod","Schilddrüsenhormon"],["Zink","Kognitive Funktion"]]},
 kraft:{n:"Muskelkraft",s:"Kraft",d:"Eiweiß, Magnesium und Mineralstoffe für Training und Regeneration.",
  nutri:[["Magnesium","Muskelkontraktion"],["Vitamin D3","Muskeln und Hormone"],["Zink","Regeneration"],["Kalium","Elektrolythaushalt"]]},
 knochen:{n:"Knochen",s:"Knochen",d:"Calcium, Vitamin D3 und K2 für die Knochendichte.",
  nutri:[["Calcium","Knochen und Zähne"],["Vitamin D3","Calciumaufnahme"],["Vitamin K2","Bindet Calcium im Knochen"],["Mangan","Bindegewebe"]]},
 herz:{n:"Herz",s:"Herz",d:"Omega-3 und Antioxidantien für das Herz-Kreislauf-System.",
  nutri:[["Omega-3 EPA","Herzfunktion"],["Vitamin K2","Elastizität der Arterien"],["Folat","DNA und rote Blutkörperchen"],["Niacin","Cholesterinspiegel"]]},
 haut:{n:"Haut und Haare",s:"Haut",d:"Biotin, Zink und Vitamin C für die Erneuerung der Gewebe.",
  nutri:[["Biotin","Haare, Haut und Nägel"],["Zink","Zellerneuerung"],["Vitamin C","Kollagenbildung"],["Vitamin E","Schutz der Haut"],["Vitamin A","Gewebeerneuerung"]]},
 altern:{n:"Gesundes Altern",s:"Altern",d:"Antioxidantien und Zellschutz über die Zeit.",
  nutri:[["Selen","Antioxidans und Schilddrüse"],["Vitamin E","Zellschutz"],["Coenzym Q10","Zelluläre Energie"],["Lutein","Augen und Sehkraft"],["Vitamin C","Abwehr und Kollagen"]]}
};
const K=Object.keys(AREE);

/* ---------- DIE 25 FRAGEN ---------- */
const Q=[
 {s:"Profil",t:"Wie heißt du?",h:"Nur, um deine Formel zu beschriften.",type:"text",lab:"Name",ph:"Dein Name"},
 {s:"Profil",t:"Wann bist du geboren?",type:"date",lab:"Geburtsdatum",
  sc:v=>{const a=new Date().getFullYear()-new Date(v).getFullYear();
         return a>=50?{knochen:3,altern:3,herz:2}:a>=35?{altern:2,herz:1}:{}}},
 {s:"Profil",t:"Biologisches Geschlecht",h:"Es verändert den Bedarf an Eisen, Calcium und anderen Nährstoffen.",type:"ch",lab:"Geschlecht",two:1,
  o:[{t:"Weiblich",p:{knochen:2,haut:1}},{t:"Männlich",p:{kraft:1}}]},
 {s:"Profil",t:"Wie groß bist du?",type:"num",unit:"cm",min:120,max:230,lab:"Größe",sc:()=>({})},
 {s:"Profil",t:"Wie viel wiegst du?",type:"num",unit:"kg",min:35,max:250,lab:"Gewicht",sc:()=>({})},

 {s:"Ziele",t:"Welche zwei Bereiche möchtest du am meisten unterstützen?",h:"Wähle genau zwei.",type:"multi",need:2,lab:"Prioritäre Bereiche",
  o:[{t:"Haut und Haare",p:{haut:6}},{t:"Kognitive Funktion",p:{geist:6}},{t:"Energie und Müdigkeit",p:{energie:6}},
     {t:"Gesundes Altern",p:{altern:6}},{t:"Herz",p:{herz:6}},{t:"Knochen",p:{knochen:6}},{t:"Muskelkraft",p:{kraft:6}}]},
 {s:"Ziele",t:"Was ist dein aktuelles Fitnessziel?",type:"ch",lab:"Fitnessziel",two:1,
  o:[{t:"Muskelmasse aufbauen",p:{kraft:5}},{t:"Gewicht verlieren",p:{energie:3,altern:2}},
     {t:"Ausdauer verbessern",p:{energie:4,herz:3}},{t:"Allgemeines Wohlbefinden unterstützen",p:{altern:3,energie:2}}]},

 {s:"Ernährung",t:"Folgst du einer oder mehreren dieser Ernährungsweisen?",h:"Mehrfachauswahl möglich.",type:"multi",lab:"Ernährungsweise",two:1,
  o:[{t:"Vegetarisch",p:{energie:3,kraft:2}},{t:"Vegan",p:{energie:5,kraft:3,knochen:2,geist:2}},
     {t:"Pescetarisch",p:{herz:1}},{t:"Glutenfrei",p:{}},{t:"Laktosefrei",p:{knochen:2}},
     {t:"Low Carb oder ketogen",p:{energie:1}},{t:"Keine besondere Ernährungsweise",p:{},x:1}]},
 {s:"Ernährung",t:"Wie oft isst du rotes Fleisch?",type:"ch",lab:"Rotes Fleisch",two:1,
  o:[{t:"Mindestens 3-mal pro Woche",p:{herz:1}},{t:"1–2-mal pro Woche",p:{}},
     {t:"Ein paar Mal im Monat",p:{energie:2}},{t:"Nie",p:{energie:4,kraft:1}}]},
 {s:"Ernährung",t:"Und Fisch oder Meeresfrüchte?",type:"ch",lab:"Fisch",two:1,
  o:[{t:"Mindestens 3-mal pro Woche",p:{}},{t:"1–2-mal pro Woche",p:{herz:1}},
     {t:"Ein paar Mal im Monat",p:{herz:3,geist:2}},{t:"Nie",p:{herz:5,geist:4}}]},
 {s:"Ernährung",t:"Wie viele Milchprodukte am Tag?",type:"ch",lab:"Milchprodukte",two:1,
  o:[{t:"Mindestens 3 am Tag",p:{}},{t:"1–2 am Tag",p:{}},{t:"Ein paar Mal im Monat",p:{knochen:3}},{t:"Nie",p:{knochen:5}}]},
 {s:"Ernährung",t:"Wie viele Portionen Obst am Tag?",type:"ch",lab:"Obst",two:1,
  o:[{t:"Mindestens 3 am Tag",p:{}},{t:"1–2 am Tag",p:{altern:1}},
     {t:"Ein paar Mal im Monat",p:{altern:3,haut:2}},{t:"Nie",p:{altern:5,haut:3}}]},
 {s:"Ernährung",t:"Und wie viele Portionen Gemüse?",h:"Salate und Suppen zählen mit.",type:"ch",lab:"Gemüse",two:1,
  o:[{t:"Mindestens 3 am Tag",p:{}},{t:"1–2 am Tag",p:{altern:1}},
     {t:"Ein paar Mal im Monat",p:{altern:3,energie:2}},{t:"Nie",p:{altern:5,energie:3}}]},
 {s:"Ernährung",t:"Wie viele Eiweißportionen am Tag?",h:"Fleisch, Fisch, Eier, Hülsenfrüchte oder Proteinshakes.",type:"ch",lab:"Eiweißportionen",two:1,
  o:[{t:"1 oder weniger",p:{kraft:5,energie:2}},{t:"2 Portionen",p:{kraft:3}},{t:"3 Portionen",p:{}},
     {t:"4 Portionen",p:{}},{t:"5 Portionen",p:{}},{t:"6 oder mehr",p:{}}]},
 {s:"Ernährung",t:"Welche Mahlzeit nimmst du zu einer festen Zeit ein?",h:"Danach richten wir dein Ernährungsfenster aus.",type:"ch",lab:"Feste Mahlzeit",two:1,
  o:[{t:"Frühstück",p:{}},{t:"Abendessen",p:{}}]},
 {s:"Ernährung",t:"Wie viele koffeinhaltige Getränke am Tag?",type:"ch",lab:"Koffein",two:1,
  o:[{t:"Mindestens 3 am Tag",p:{energie:3}},{t:"1–2 am Tag",p:{energie:1}},{t:"Ein paar Mal im Monat",p:{}},{t:"Nie",p:{}}]},
 {s:"Ernährung",t:"Wie viel Flüssigkeit trinkst du täglich?",h:"Wasser, Tee, Kaffee, Milch, Säfte. Ein Glas = 250 ml.",type:"ch",lab:"Flüssigkeit",two:1,
  o:[{t:"Weniger als 4 Gläser",p:{energie:3,haut:3}},{t:"5 Gläser",p:{energie:2,haut:2}},{t:"6 Gläser",p:{haut:1}},
     {t:"7 Gläser",p:{}},{t:"8 Gläser",p:{}},{t:"9 Gläser",p:{}},{t:"10 Gläser",p:{}},
     {t:"11 Gläser",p:{}},{t:"12 oder mehr",p:{}}]},
 {s:"Ernährung",t:"Wie viele zuckerhaltige Getränke am Tag?",h:"Limonaden, süße Säfte, Energydrinks.",type:"ch",lab:"Zuckerhaltige Getränke",two:1,
  o:[{t:"Keine",p:{}},{t:"1 am Tag",p:{altern:1}},{t:"2 am Tag",p:{altern:3}},{t:"3 oder mehr",p:{altern:5,herz:2}}]},

 {s:"Bewegung",t:"Wie würdest du dein Aktivitätsniveau beschreiben?",type:"ch",lab:"Aktivitätsniveau",two:1,
  o:[{t:"Sitzend oder eingeschränkt mobil",p:{energie:3,knochen:3,herz:2}},
     {t:"Leichte Aktivität: Büro, wenig Bewegung",p:{energie:2,knochen:1}},
     {t:"Mäßig aktiv: 1–3 Trainings pro Woche",p:{kraft:2}},
     {t:"Sehr aktiv: fast täglich Training",p:{kraft:4,energie:2}}]},
 {s:"Bewegung",t:"Welche Art von Aktivität machst du?",h:"Mehrfachauswahl möglich.",type:"multi",lab:"Art der Aktivität",two:1,
  o:[{t:"Krafttraining oder Fitnessstudio",p:{kraft:4,knochen:2}},{t:"Laufen, Radfahren oder Schwimmen",p:{herz:3,energie:2}},
     {t:"Mannschaftssport",p:{kraft:2,herz:2}},{t:"Yoga, Pilates oder Dehnen",p:{geist:2}},
     {t:"Spaziergänge",p:{herz:1}},{t:"Keine Aktivität",p:{knochen:2,kraft:1},x:1}]},
 {s:"Bewegung",t:"An wie vielen Tagen pro Woche trainierst du?",type:"ch",lab:"Trainingstage",two:1,
  o:[{t:"Ich trainiere nicht",p:{knochen:2}},{t:"1 Tag",p:{}},{t:"2 Tage",p:{kraft:1}},
     {t:"3 Tage",p:{kraft:2}},{t:"4 Tage",p:{kraft:3}},{t:"5 oder mehr",p:{kraft:4,energie:2}}]},

 {s:"Befinden",t:"Fühlst du dich nach einer normalen Nacht ausgeruht?",type:"ch",lab:"Erholung nach dem Schlaf",two:1,
  o:[{t:"Ja",p:{}},{t:"Nein",p:{energie:5,geist:2}}]},
 {s:"Befinden",t:"Fühlst du dich tagsüber energiegeladen und wach?",type:"ch",lab:"Energie und Wachheit",two:1,
  o:[{t:"Ja",p:{}},{t:"Nein",p:{energie:5,geist:3}}]},
 {s:"Befinden",t:"Was soll deine Formel unterstützen?",h:"Mehrfachauswahl möglich.",type:"multi",lab:"Gewünschte Unterstützung",
  o:[{t:"Müdigkeit und Erschöpfung verringern",p:{energie:5}},{t:"Alltagsstress bewältigen",p:{geist:4,energie:2}},
     {t:"Normale Sehkraft unterstützen",p:{altern:3,geist:1}},{t:"Immunsystem stärken",p:{altern:3,haut:1}},
     {t:"Schlafqualität verbessern",p:{energie:3,geist:2}},{t:"Nichts davon",p:{},x:1}]},
 {s:"Befinden",t:"Wie geht es Haut, Haaren und Nägeln zurzeit?",h:"Mehrfachauswahl möglich.",type:"multi",lab:"Haut und Haare",two:1,
  o:[{t:"Brüchiges Haar oder Haarausfall",p:{haut:4}},{t:"Fahle oder trockene Haut",p:{haut:3}},
     {t:"Brüchige Nägel",p:{haut:3}},{t:"Alles im normalen Bereich",p:{},x:1}]}
];

const SAFE=[
 {t:"Hast du Allergien oder Unverträglichkeiten?",h:"Mehrfachauswahl. Dient dazu, Zutaten aus der Formel auszuschließen.",type:"multi",lab:"Allergien",two:1,
  o:[{t:"Laktose"},{t:"Gluten"},{t:"Nüsse"},{t:"Soja"},{t:"Krustentiere oder Fisch"},
     {t:"Andere — ich gebe sie in den Anmerkungen an",f:1},{t:"Keine",x:1}]},
 {t:"Trifft eine dieser Situationen auf dich zu?",h:"Mehrfachauswahl möglich.",type:"multi",lab:"Medizinische Hinweise",two:1,
  o:[{t:"Ich nehme regelmäßig Medikamente",f:1},{t:"Ich bin schwanger oder stille",f:1},
     {t:"Ich habe eine bestehende Erkrankung",f:1},{t:"Nichts davon",x:1}]}
];
const ALL=Q.concat(SAFE.map(x=>Object.assign({s:"Sicherheit",extra:1},x)));

/* ---------- ENGINE ---------- */
const st={i:0,a:new Array(ALL.length).fill(null),plan:false,up:new Set()};
const stage=n=>R.querySelectorAll(".fq-stage").forEach(e=>e.classList.toggle("on",e.dataset.s===n));
const CX=150,CY=140,RR=98;
const pt=(i,v)=>{const a=-Math.PI/2+i*2*Math.PI/7,r=14+RR*v;return[CX+r*Math.cos(a),CY+r*Math.sin(a)];};
(function(){let g="";
 [.34,.67,1].forEach(f=>{g+=`<polygon class="fq-ring" points="${K.map((_,i)=>pt(i,f).map(n=>n.toFixed(1)).join(",")).join(" ")}"/>`;});
 K.forEach((k,i)=>{const[x,y]=pt(i,1);g+=`<line class="fq-axis" x1="${CX}" y1="${CY}" x2="${x.toFixed(1)}" y2="${y.toFixed(1)}"/>`;
  const[lx,ly]=pt(i,1.25);
  g+=`<text class="fq-lab" x="${lx.toFixed(1)}" y="${(ly+3).toFixed(1)}" text-anchor="middle">${AREE[k].s.toUpperCase()}</text>`;});
 var _sc=$("#fq-scaffold"); if(_sc) _sc.innerHTML=g;})();

function scores(){const t={};K.forEach(k=>t[k]=0);
 st.a.forEach(a=>{if(!a)return;(a.ps||(a.p?[a.p]:[])).forEach(p=>{for(const k in p)t[k]+=p[k];});});return t;}
function radar(){var poly=$("#fq-poly"); if(!poly) return;
 const t=scores(),m=Math.max(6,...Object.values(t));
 poly.setAttribute("d","M"+K.map((k,i)=>pt(i,.1+.9*(t[k]/m)).map(n=>n.toFixed(1)).join(",")).join("L")+"Z");
 const n=st.a.filter(Boolean).length;
 var rf=$("#fq-rf"); if(rf) rf.textContent=n?n+" Antworten gelesen":"Warte auf die erste Antwort";}
radar();

function render(){
 const q=ALL[st.i],a=st.a[st.i];
 $("#fq-sec").textContent=q.s;$("#fq-cur").textContent=Math.min(st.i+1,25);
 $("#fq-fill").style.width=(st.i/ALL.length*100)+"%";
 let body="";
 if(q.type==="ch"||q.type==="multi"){
  body=`<div class="fq-opts${q.two?" two":""}">`+q.o.map((o,k)=>{
   const on=q.type==="multi"?(a&&a.ks.includes(k)):(a&&a.k===k);
   return `<button class="fq-opt${on?" sel":""}" data-k="${k}">
    ${q.type==="multi"?`<span class="fq-k box">${on?"✓":"&nbsp;"}</span>`:""}
    <span>${o.t}</span></button>`;}).join("")+`</div>`;
 } else if(q.type==="num"){
  body=`<div class="fq-inrow"><input class="fq-in" type="number" id="fq-x" min="${q.min}" max="${q.max}" value="${a?a.v:""}" placeholder="—"><span class="fq-unit">${q.unit}</span></div>`;
 } else if(q.type==="date"){
  body=`<input class="fq-in" type="date" id="fq-x" value="${a?a.raw:""}">`;
 } else {
  body=`<input class="fq-in" type="text" id="fq-x" value="${a?a.v:""}" placeholder="${q.ph||""}">`;
 }
 const badge=q.type==="multi"?`<span class="fq-badge">${q.need?"Genau "+q.need+" wählen":"Mehrfachauswahl"}</span>`:"";
 const num=q.extra?"Letzter Schritt":"Frage "+String(st.i+1).padStart(2,"0");
 $("#fq-q").innerHTML=`<div class="fq-qn">${num}</div><h2>${q.t}</h2>${q.h?`<p class="fq-hint">${q.h}</p>`:""}${badge}${body}`;

 if(q.type==="ch"||q.type==="multi"){
  $("#fq-q").querySelectorAll(".fq-opt").forEach(b=>b.addEventListener("click",()=>{
   const k=+b.dataset.k;
   if(q.type==="multi"){
    let ks=(st.a[st.i]&&st.a[st.i].ks)||[];
    if(q.o[k].x){ks=ks.includes(k)?[]:[k];}
    else{ks=ks.filter(x=>!q.o[x].x);
         ks=ks.includes(k)?ks.filter(x=>x!==k):ks.concat(k);
         if(q.need&&ks.length>q.need)ks=ks.slice(-q.need);}
    st.a[st.i]=ks.length?{ks,v:ks.map(x=>q.o[x].t).join(", "),ps:ks.map(x=>q.o[x].p||{}),
      f:ks.some(x=>q.o[x].f),ok:q.need?ks.length===q.need:true}:null;
    render();radar();
    if(q.need&&st.a[st.i]&&st.a[st.i].ok)setTimeout(next,260);
   } else {
    st.a[st.i]={k,v:q.o[k].t,p:q.o[k].p||{},f:!!q.o[k].f};
    render();radar();setTimeout(next,220);
   }
  }));
 } else {
  const x=$("#fq-x");
  x.addEventListener("input",()=>{
   if(q.type==="num"){const v=+x.value;st.a[st.i]=(v>=q.min&&v<=q.max)?{v,p:q.sc(v)}:null;}
   else if(q.type==="date"){st.a[st.i]=x.value?{raw:x.value,v:x.value.split("-").reverse().join("."),p:q.sc(x.value)}:null;}
   else{st.a[st.i]=x.value.trim().length>1?{v:x.value.trim(),p:{}}:null;}
   sync();radar();
  });
  x.focus();
 }
 R.querySelector('[data-a="back"]').style.visibility=st.i===0?"hidden":"visible";
 sync();
}
function sync(){
 const a=st.a[st.i],q=ALL[st.i],ok=a&&(q.type!=="multi"||a.ok);
 const b=R.querySelector('[data-a="next"]');
 b.disabled=!ok;b.textContent=st.i===ALL.length-1?"Formel erstellen":"Weiter";
}
function next(){if(st.i<ALL.length-1){st.i++;render();}else analyse();}

function analyse(){
 stage("load");window.scrollTo({top:0});
 let p=0;
 const t=setInterval(()=>{
  p+=Math.random()*7+2;
  if(p>=100){p=100;clearInterval(t);setTimeout(results,450);}
  $("#fq-pc").textContent=Math.floor(p)+"%";
  $("#fq-arc").style.strokeDashoffset=478-(478*p/100);
  $("#fq-lt").textContent=p<35?"Deine Antworten werden ausgewertet":p<70?"Abgleich mit deinem Bedarf":"Formel wird zusammengestellt";
 },110);
}

const F=C.formula;
const eu=n=>{var w=(C.waehrung||"€");return n.toFixed(2).replace(".",",")+" "+w;};
const hasVergleich = F.preisVergleich && F.preisVergleich > F.preis;
const rabatt = hasVergleich ? Math.round((1-F.preis/F.preisVergleich)*100) : 0;

function results(){
 const t=scores(),rank=K.map(k=>({k,v:t[k]})).sort((a,b)=>b.v-a.v);
 st.rank=rank;
 const max=Math.max(1,rank[0].v);
 const name=st.a[0]?st.a[0].v:null;

 $("#fq-jar2").innerHTML=jar();
 $("#fq-title").textContent=name?`${name}, deine Formel ist fertig.`:"Deine Formel ist fertig.";
 $("#fq-sub").textContent="Wir haben alle 25 Antworten gelesen. Das sind die Bereiche, an denen deine Formel zuerst arbeitet.";

 $("#fq-top").innerHTML=rank.slice(0,3).map((p,i)=>
  `<div class="fq-card"><div class="r">Priorität ${i+1}</div><h3>${AREE[p.k].n}</h3>
   <p>${AREE[p.k].d}</p><div class="fq-m"><i style="width:${Math.max(20,Math.round(p.v/max*100))}%"></i></div></div>`).join("");

 const seen=new Set(),nutri=[];
 rank.slice(0,3).forEach(p=>AREE[p.k].nutri.forEach(([n,d])=>{if(!seen.has(n)){seen.add(n);nutri.push([n,d]);}}));
 $("#fq-nlist").innerHTML=nutri.map(([n,d])=>
  `<div class="fq-n"><span class="g"></span><span><b>${n}</b><span>${d}</span></span></div>`).join("");

 const flag=st.a.some(a=>a&&a.f);
 $("#fq-flag").innerHTML=flag
  ? `<div class="fq-flag"><b>Wir melden uns, bevor deine Formel hergestellt wird.</b>
     Du hast etwas angegeben, das geprüft werden muss — Medikamente, Schwangerschaft, eine Erkrankung oder eine Allergie, die nicht in der Liste steht.
     Du kannst die Bestellung abschließen; wir melden uns aber vorher bei dir und empfehlen dir, deine Ärztin oder deinen Arzt zu fragen.</div>`
  : "";

 const tag=$("#fq-tag");
 if(hasVergleich){tag.textContent=`${rabatt}% Rabatt`;tag.style.display="inline-block";}
 else{tag.style.display="none";}
 $("#fq-buyt").textContent=name?`Die Formel von ${name}`:"Deine persönliche Formel";
 $("#fq-price").innerHTML=`<span class="now">${eu(F.preis)}</span>`+
   (hasVergleich?`<span class="was">Statt ${eu(F.preisVergleich)}</span><span class="off">Du sparst ${eu(F.preisVergleich-F.preis)}</span>`:"");
 $("#fq-det").textContent=F.detail;

 const keys=rank.slice(0,3).map(p=>p.k);
 let picks=C.upsell.filter(u=>u.bereiche.some(b=>keys.includes(b))).slice(0,C.maxUpsell);
 if(!picks.length)picks=C.upsell.slice(0,C.maxUpsell);
 $("#fq-ul").innerHTML=picks.map(u=>
  `<button class="fq-u" data-u="${u.id}">
   <span class="fq-uc">✓</span>
   ${u.bild?`<img class="fq-uimg" src="${u.bild}" alt="">`:`<span class="fq-uimg fq-uimg--ph"></span>`}
   <span class="fq-ub"><b>${u.name}</b><span>${u.warum}</span></span>
   <span class="fq-upr">${eu(u.preis)}</span></button>`).join("");
 $("#fq-ul").querySelectorAll(".fq-u").forEach(b=>b.addEventListener("click",()=>{
  const id=b.dataset.u;
  st.up.has(id)?st.up.delete(id):st.up.add(id);
  b.classList.toggle("sel",st.up.has(id));recalc();
 }));

 st.plan=true;recalc();
 stage("res");window.scrollTo({top:0});
}

function recalc(){
 let tot=st.plan?F.preis:0;
 st.up.forEach(id=>{const u=C.upsell.find(x=>x.id===id);if(u)tot+=u.preis;});
 $("#fq-tot").textContent=st.plan?eu(tot):"—";
 const cons=["#fq-c1","#fq-c2","#fq-c3","#fq-c4"].every(s=>{var el=$(s);return !el||el.checked;});
 R.querySelector('[data-a="cart"]').disabled=!(st.plan&&cons);
}
R.addEventListener("change",e=>{if(e.target.matches("#fq-c1,#fq-c2,#fq-c3,#fq-c4"))recalc();});


/* --- aggiorna il contatore del carrello nell'header (Dawn e temi simili) --- */
function updateCartBadge(n){
  var sel=[".cart-count-bubble span[aria-hidden]",".cart-count-bubble span",
           "#cart-icon-bubble .cart-count-bubble span","#CartCount",".cart-item-count",
           "[data-cart-count]",".site-header__cart-count",".header__cart-count"];
  var done=false;
  sel.forEach(function(s){
    document.querySelectorAll(s).forEach(function(el){ el.textContent=n; done=true; });
  });
  // se il pallino non esiste ancora (carrello vuoto all'apertura), lo creo
  if(!done){
    var icon=document.querySelector("#cart-icon-bubble, a[href$='/cart'], .header__icon--cart");
    if(icon && n>0 && !icon.querySelector(".cart-count-bubble")){
      var b=document.createElement("div");
      b.className="cart-count-bubble";
      b.innerHTML='<span aria-hidden="true">'+n+'</span>';
      icon.appendChild(b);
    }
  }
}

async function addToCart(){
 const btn=R.querySelector('[data-a="cart"]'),msg=$("#fq-msg");
 btn.disabled=true;btn.textContent="Wird hinzugefügt…";
 const props={
  "Formel":st.rank.slice(0,3).map(p=>AREE[p.k].n).join(" · "),
  "Fragebogen":"25/25 Antworten angehängt"
 };
 ALL.forEach((q,i)=>{
  const a=st.a[i];
  const key=q.extra?"_★ "+q.lab:"_"+String(i+1).padStart(2,"0")+". "+q.lab;
  props[key]=a?(a.v+(q.unit?" "+q.unit:"")):"—";
 });
 if(st.a.some(a=>a&&a.f))props["_⚠️ PRÜFEN"]="Ja — Kundin/Kunde kontaktieren";

 // normalizza un variantId in intero pulito (evita notazione scientifica, spazi, decimali)
 function vid(x){
   if(typeof x==="number") return Math.round(x);
   var n=String(x).trim().replace(/[^\d]/g,"");   // tiene solo le cifre
   return n?parseInt(n,10):0;
 }
 const items=[{id:vid(F.variantId),quantity:1,properties:props}];
 st.up.forEach(id=>{const u=C.upsell.find(x=>x.id===id);if(u)items.push({id:vid(u.variantId),quantity:1});});

 if(C.demo){FQ_DIRTY=false;
  console.log("FQ — payload für /cart/add.js:",{items});
  msg.className="fq-msg ok";
  msg.textContent="Demo-Modus. Öffne die Browser-Konsole: dort stehen alle Antworten. Setze demo: false, wenn du live gehst.";
  btn.disabled=false;btn.textContent="In den Warenkorb";return;
 }
 try{
  const r=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items})});
  if(!r.ok)throw new Error(await r.text());
  FQ_DIRTY=false;

  // --- 1. conferma che il prodotto è DAVVERO nel carrello (fino a 5 tentativi) ---
  var count=0;
  for(var attempt=0; attempt<5; attempt++){
    try{
      var cr=await fetch("/cart.js",{headers:{"Accept":"application/json"},cache:"no-store"});
      var cart=await cr.json();
      count=cart.item_count||0;
      if(count>0) break;               // il carrello contiene già l'item: procedi
    }catch(e){}
    await new Promise(function(r){ setTimeout(r,150); });  // aspetta e riprova
  }
  console.log("FQ: carrello confermato, articoli =",count);
  updateCartBadge(count);

  // --- 2. l'app AMP slide-cart è inaffidabile su questo tema (mostra vuoto anche con articoli).
  //         Non apriamo il suo drawer: aggiorniamo il badge e diamo una conferma chiara.
  try{ if(window.Shopify && Shopify.actions && typeof Shopify.actions.cartUpdate==="function") Shopify.actions.cartUpdate(); }catch(e){}
  try{ document.documentElement.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:true})); }catch(e){}
  try{ if(window.jQuery){ jQuery(document.body).trigger("added_to_cart"); } }catch(e){}

  // conferma inline forte: è QUESTA il segnale al cliente (il drawer AMP è inaffidabile)
  msg.className="fq-msg ok fq-added";
  msg.innerHTML=
    '<div class="fq-added-in">'+
      '<span class="fq-added-ic">✓</span>'+
      '<div class="fq-added-tx"><b>Zu deinem Warenkorb hinzugefügt'+(count?' ('+count+' Artikel)':'')+'</b>'+
        '<span>Du kannst weitere Produkte hinzufügen oder direkt zur Kasse gehen.</span></div>'+
      '<a class="fq-added-btn" href="/cart">Zum Warenkorb →</a>'+
    '</div>';
  msg.scrollIntoView({behavior:"smooth",block:"center"});
  btn.textContent="Hinzugefügt ✓";
  setTimeout(function(){ btn.disabled=false; btn.textContent="In den Warenkorb"; }, 1500);
 }catch(e){
  console.error(e);
  msg.className="fq-msg err";
  var det=(e&&e.message)?String(e.message):"";
  try{ var j=JSON.parse(det); det=(j.description||j.message||det); }catch(_){}
  msg.textContent="Konnte nicht hinzugefügt werden. "+(det?("Shopify: "+det.slice(0,220)):"Bitte erneut versuchen.");
  console.error("FQ add-to-cart error:", e);
  btn.disabled=false;btn.textContent="In den Warenkorb";
 }
}

R.addEventListener("click",e=>{
 const b=e.target.closest("[data-a]");if(!b)return;
 const a=b.dataset.a;
 if(a==="start"){FQ_DIRTY=true;stage("quiz");render();radar();window.scrollTo({top:0});}
 if(a==="back"&&st.i>0){st.i--;render();}
 if(a==="next")next();
 if(a==="pick"){$("#fq-c1").scrollIntoView({behavior:"smooth",block:"center"});}
 if(a==="cart")addToCart();
 if(a==="restart"){FQ_DIRTY=false;location.reload();}
});
/* --- Avviso prima di ricaricare/uscire mentre il quiz è in corso --- */
window.addEventListener("beforeunload",function(e){
  if(FQ_DIRTY){ e.preventDefault(); e.returnValue=""; return ""; }
});
document.addEventListener("keydown",e=>{
 if(!R.querySelector('[data-s="quiz"]').classList.contains("on"))return;
 const q=ALL[st.i];
 if(q.type==="ch"&&/^[1-9]$/.test(e.key)){
  const b=$("#fq-q").querySelector(`.fq-opt[data-k="${+e.key-1}"]`);if(b)b.click();
 }
 if(e.key==="Enter"&&!R.querySelector('[data-a="next"]').disabled)R.querySelector('[data-a="next"]').click();
});
})();